import React, { useEffect, useState } from 'react';
import { XY_CMP_GROUP_SET, GetXYComparisonGroupList, GroupListType } from '../../../function/GroupDataModel';
import GroupSelectGrid, { SelectGroupType } from '../../organisms/Pages/GroupSelectGrid';
import { useHistory } from 'react-router-dom';
import { makeStyles, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  createStyles({
    paper: {
      padding: '10px',
      background: '#FFFFEE',
    },
    tableContainer: { maxHeight: 'calc(100vh - 210px)' },
  })
);

type Props = {
  /**
   * 初期表示時の絞り込みパラメータ
   */
  defalutGropuNos?: number[];
};

const XYDiagramGroupSelectPage: React.FC<Props> = (props) => {
  const defalutGropuNos: number[] = props.defalutGropuNos ?? [];
  const history = useHistory();
  const classes = useStyles();
  const [groupDt, setGroupDt] = useState<XY_CMP_GROUP_SET[]>([]);
  const [groupList, setGroupList] = useState<SelectGroupType[]>([]);

  useEffect(() => {
    //XYのグループテーブル設定取得
    GetXYComparisonGroupList().then((ret) => {
      var fillter = ret.XY_CMP_GROUP_SETs.filter((item) => item.DSP_FLG == 1);
      setGroupDt(fillter);
    });
  }, []);

  useEffect(() => {
    var lists: SelectGroupType[] = [];
    console.debug(['defalutGropuNo', defalutGropuNos]);
    if (defalutGropuNos.length === 0) {
      for (var i in groupDt) {
        lists.push({ index: Number(i) + 1, groupName: groupDt[i].GROUP_NAME, groupNo: groupDt[i].GROUP_NO });
      }
    } else {
      var filterDt = groupDt.filter((row) => defalutGropuNos.find((row2) => row.GROUP_NO === row2) !== undefined);
      for (var i in filterDt) {
        lists.push({
          index: Number(i) + 1,
          groupName: filterDt[i].GROUP_NAME,
          groupNo: filterDt[i].GROUP_NO,
        });
      }
    }
    setGroupList(lists);
    console.debug(lists);
  }, [groupDt]);

  const groupSelect = (selectdata: SelectGroupType) => {
    var target = groupDt.find((row) => row.GROUP_NO == selectdata.groupNo);
    history.push({
      pathname: '/XYDiagramPage',
      state: target,
    });
  };

  return <GroupSelectGrid groupList={groupList} onSelect={groupSelect} tableContainerStyle={classes.tableContainer} />;
};

export default XYDiagramGroupSelectPage;
